





















import Vue from 'vue';
import { EmailSettings } from '~/services/CommunicationService';
import CommunicationSkeleton from '../skeletons/CommunicationSkeleton.vue';

export default Vue.extend({
    name: 'Communication',
    components: { CommunicationSkeleton },
    props: {
        value: {
            type: Object as () => EmailSettings,
            default: () => ({ subscriptions: { newsletters: true } } as EmailSettings),
        }, // EmailSettings
        isLoading: Boolean,
    },
    computed: {
        newsletters(): boolean {
            return this.value && this.value.subscriptions
                ? this.value.subscriptions.newsletters
                : true;
        },
    },
    methods: {
        onConsentChange(checked: boolean): void {
            let newEmailSettings = Object.assign({}, this.value || {});
            newEmailSettings.subscriptions.newsletters = checked;
            this.$emit('input', newEmailSettings);
        },
    },
});
